module.exports = __webpack_public_path__ + "static/media/Loading.a90e737d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Loading.gif
// module id = 69
// module chunks = 0